import log from "loglevel";

const canvasToBlob = canvas => {
  return new Promise(resolve => {
    if (typeof canvas.toBlob == "function") {
      canvas.toBlob(blob => {
        resolve(blob);
      });
    } else {
      const binStr = atob(canvas.toDataURL().split(",")[1]);
      const len = binStr.length;
      const arr = new Uint8Array(len);

      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }

      resolve(new Blob([arr]));
    }
  });
};

export default {
  generateBlankSpineImage: (canvas = null) => {
    return new Promise(resolve => {
      let canvasWidth = 960 / 2;
      let canvasHeight = 960;

      // canvas領域が規定値より大きい場合、規定値に合わせて縮小する
      // ※ iOS でのcanvas領域制限 : 16777216
      const maxCanvasArea = 16777210;
      if (canvasWidth * canvasHeight > maxCanvasArea) {
        let aspectRatio = canvasHeight / canvasWidth;

        canvasWidth = Math.sqrt(maxCanvasArea / aspectRatio);
        canvasHeight = canvasWidth * aspectRatio;
      }

      if (canvas == null) {
        canvas = document.createElement("canvas");
      }

      canvas.width = canvasWidth;
      canvas.height = canvasHeight;
      const context = canvas.getContext("2d");

      context.fillStyle = "#FFFFFF";
      context.fillRect(0, 0, canvasWidth, canvasHeight);

      canvasToBlob(canvas).then(blob => {
        resolve(blob);
      });
    });
  },

  generateDefaultSpineImage: (
    imageUrl,
    pageProgressionDirection,
    canvas = null
  ) => {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.crossOrigin = "anonymous";
      image.src = imageUrl;
      image.onload = () => {
        let canvasWidth = image.naturalHeight / 2;
        let canvasHeight = image.naturalHeight;

        // canvas領域が規定値より大きい場合、規定値に合わせて縮小する
        // ※ iOS でのcanvas領域制限 : 16777216
        const maxCanvasArea = 16777210;
        if (canvasWidth * canvasHeight > maxCanvasArea) {
          let aspectRatio = canvasHeight / canvasWidth;

          canvasWidth = Math.sqrt(maxCanvasArea / aspectRatio);
          canvasHeight = canvasWidth * aspectRatio;
        }

        if (canvas == null) {
          canvas = document.createElement("canvas");
        }

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const context = canvas.getContext("2d");
        if (pageProgressionDirection === "ltr") {
          context.drawImage(
            image,
            0,
            0,
            1,
            image.naturalHeight,
            0,
            0,
            canvasWidth,
            canvasHeight
          );
        } else if (pageProgressionDirection === "rtl") {
          context.drawImage(
            image,
            image.naturalWidth - 1,
            0,
            1,
            image.naturalHeight,
            0,
            0,
            canvasWidth,
            canvasHeight
          );
        } else {
          reject("invalid pageProgressionDirection");
        }

        canvasToBlob(canvas).then(blob => {
          resolve(blob);
        });
      };

      image.onerror = () => {
        log.error("image onerror:", image);

        reject("image onerror");
      };
    });
  },

  generateSpineImage: (imageUrl, aspectRatio, canvas = null) => {
    return new Promise((resolve, reject) => {
      const image = new Image();

      image.crossOrigin = "anonymous";
      image.src = imageUrl;
      image.onload = () => {
        let canvasWidth = 0;
        let canvasHeight = 0;
        if (aspectRatio > image.naturalHeight / image.naturalWidth) {
          canvasWidth = Math.ceil(image.naturalHeight / aspectRatio);
          canvasHeight = image.naturalHeight;
        } else {
          canvasWidth = image.naturalWidth;
          canvasHeight = Math.ceil(image.naturalWidth * aspectRatio);
        }

        // canvas領域が規定値より大きい場合、規定値に合わせて縮小する
        // ※ iOS でのcanvas領域制限 : 16777216
        const maxCanvasArea = 16777210;
        if (canvasWidth * canvasHeight > maxCanvasArea) {
          let aspectRatio = canvasHeight / canvasWidth;

          canvasWidth = Math.sqrt(maxCanvasArea / aspectRatio);
          canvasHeight = canvasWidth * aspectRatio;
        }

        if (canvas == null) {
          canvas = document.createElement("canvas");
        }

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;
        const context = canvas.getContext("2d");

        if (aspectRatio > image.naturalHeight / image.naturalWidth) {
          const srcWidth = canvasWidth * (image.naturalHeight / canvasHeight);
          context.drawImage(
            image,
            (image.naturalWidth - srcWidth) / 2,
            0,
            srcWidth,
            image.naturalHeight,
            0,
            0,
            canvasWidth,
            canvasHeight
          );
        } else {
          const srcHeight = canvasHeight * (image.naturalWidth / canvasWidth);
          context.drawImage(
            image,
            0,
            (image.naturalHeight - srcHeight) / 2,
            image.naturalWidth,
            srcHeight,
            0,
            0,
            canvasWidth,
            canvasHeight
          );
        }

        canvasToBlob(canvas).then(blob => {
          resolve(blob);
        });
      };

      image.onerror = () => {
        log.error("image onerror:", image);

        reject("image onerror");
      };
    });
  }
};
